<template>
</template>

<script>
    import constants from '../../constants'
    import FPSManager from '../../FPSManager'
    import YokumiruHelper from '../../YokumiruHelper'
    import moment from 'moment-timezone'

    const fps = new FPSManager( {
        fps: 1,
    } );

    export default {
        props: {
            userType: {
                type: String,
                default: 'user',
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                consultation: null,
                current: null,
                start: null,
                end: null,
                frame: null,
                notified: {
                    start: false,
                    end: false,
                },
                finished: false,
            }
        },

        created: function () {
            this.fetchConsultationNext()
            bus.$on('user-reservation-completed', this.fetchConsultationNext)
        },

        beforeDestroy: function () {
            bus.$off('user-reservation-completed')
        },

        methods: {
            /**
             * 次回診療予約の取得
             */
            fetchConsultationNext: function () {
                this.consultation = null
                let endpoint = ''

                if ( this.userType === 'user' ) {
                    endpoint = constants.user.consultations.endpoint.nextTime
                }
                else if ( this.userType === 'doctor' ) {
                    endpoint = constants.doctor.consultations.endpoint.nextTime
                }

                axios.get(endpoint).then(({data}) => {
                    this.consultation = data.data
                    this.init()
                })
            },

            /**
             * 初期化処理
             */
            init: function() {
                cancelAnimationFrame(this.frame)

                this.notified.start = false
                this.notified.end = false
                this.finished = false

                if (this.consultation != null) {
                    this.start = moment.tz(this.consultation.start_time, 'Asia/Tokyo')
                    this.end = moment.tz(this.consultation.end_time, 'Asia/Tokyo')
                    this.countdown()
                }
            },

            /**
             * カウントダウン処理
             */
            countdown: function() {
                this.frame = requestAnimationFrame(this.countdown)
                fps.tick(this.elapse)
            },

            /**
             * 1秒経過時
             * 時間更新とアラート処理
             */
            elapse: function () {
                this.current = this.helper.jstTimeNow()
                const diffStart = Math.floor(this.current.diff(this.start, 'minutes', true))
                const diffEnd = Math.floor(this.current.diff(this.end, 'minutes', true))

                if (!this.notified.start && diffStart === -5) {
                    bus.$emit('alert-warning', `${this.$locale.consultation_host}開始5分前になりました。`, null)
                    this.notified.start = true
                }

                if (!this.notified.end && diffEnd === -5) {
                    this.notified.end = true
                }

                if (!this.finished && diffEnd >= 0) {
                    this.finished = true
                    this.fetchConsultationNext()
                }
            },
        },
    }
</script>
